import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "format-key": "0" }
const _hoisted_2 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.sectionClass)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass($options.wrapperClass),
      "data-qa": "project-description-section:Legal entity info"
    }, [
      _createCommentVNode(" Creator responsible for this project: this.legalEntityName doing business as this.creatorName. "),
      _createElementVNode("span", null, _toDisplayString($options.legalEntityInformation), 1 /* TEXT */),
      ($options.hasCustomTos)
        ? (_openBlock(), _createBlock(_component_localize, {
            key: 0,
            resource: _ctx.Resources.ProjectHome.AcceptingStoreTermsOfServiceText
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString($options.legalEntityName), 1 /* TEXT */),
              _createElementVNode("a", {
                "format-key": "1",
                class: "gfu-link gfu-link--accent",
                href: $options.customTosUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                "data-qa": "legal-entity-information-link:CustomTermsOfService"
              }, _toDisplayString(_ctx.Resources.ProjectHome.CustomTermsOfServiceLink), 9 /* TEXT, PROPS */, _hoisted_2)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}